import {
  VideoItemType,
  VideoItemTypeApi,
  VideoType,
} from '@hhgtech/hhg-components/types'

export enum SessionsType {
  HeadingBanner = 'heading_banner',
  FeatureVideo = 'featured_video',
  ShortsVideo = 'shorts_video',
  HCPVideo = 'hcp_videos',
  CategoriesVideo = 'categories_video',
}

export interface CommonSessionTypeApi {
  session_layout: string
  title: string
}

export interface CommonSessionType {
  sessionLayout: string
  title: string
}

export type HeadingBannerTypeApi = {
  description: string
  background_banner: string
  full_width_banner: boolean
  banner_mobile: string
  banner_desktop: string
} & CommonSessionTypeApi

export type HeadingBannerType = {
  description: string
  backgroundBanner: string
  fullWidthBanner: boolean
  bannerMobile: string
  bannerDesktop: string
} & CommonSessionType

export type FeatureVideoTypeApi = {
  videos: VideoItemTypeApi[]
  other_tab_name: {
    video_type: VideoType
    tab_name: string
  }[]
} & CommonSessionTypeApi

export type FeatureVideoType = {
  videos: VideoItemType[]
  tabList: {
    type: VideoType
    name: string
  }[]
} & CommonSessionType

export type SessionComponentTypeApi = {
  layout: 'list' | 'grid'
  videos: VideoItemTypeApi[]
  read_more: string
  session_id: string
} & CommonSessionTypeApi

export type SessionComponentType = {
  layout: 'list' | 'grid' | ''
  videos: VideoItemType[]
  readMore: string
  sessionId: string
} & CommonSessionType

export type VideosSessionListTypeApi =
  | HeadingBannerTypeApi
  | FeatureVideoTypeApi
  | SessionComponentTypeApi
export type VideosSessionListType =
  | HeadingBannerType
  | FeatureVideoType
  | SessionComponentType

export type VideosPageTypeApi = {
  name: string
  list_sessions: VideosSessionListTypeApi[]
  meta_tag: string
  disable_ad: boolean
}

export type VideosPageType = {
  name: string
  listSessions: VideosSessionListType[]
  metaTag: string
  disableAd: boolean
}
